/* ============================================================
   KROQ — Vus récemment

   · Sur une fiche produit, retient le produit consulté
     ([data-kroq-vus-courant]) dans localStorage : 12 au plus, le plus
     récent d'abord, sur l'appareil du visiteur seulement.
   · <kroq-vus-recemment> affiche les derniers produits vus, rendus par
     Shopify lui-même via le Section Rendering API : même carte, même
     prix, mêmes badges que partout ailleurs.

   Attributs du composant :
     data-format   'carte' (fiche produit) | 'mini' (panier)
     data-max      nombre de produits affichés
     data-exclure  handles à écarter, séparés par des virgules (le produit
                   courant, ou ceux déjà au panier). Horizon met cet
                   attribut à jour quand il redessine le panier : le bloc
                   se recalcule alors de lui-même.

   Le conteneur de la liste porte data-skip-subtree-update : le redessin
   du panier par Horizon (morph) ne l'efface pas. L'affichage se règle en
   CSS (visible seulement si la liste a des enfants) et non par l'attribut
   `hidden`, que le redessin remettrait à chaque fois.

   Chaque rendu est gardé 30 minutes en sessionStorage : ouvrir et
   refermer le panier ne relance aucune requête.
   ============================================================ */
(function () {
  'use strict';

  if (window.customElements && customElements.get('kroq-vus-recemment')) return;

  var CLE = 'kroq-vus';
  var CLE_CACHE = 'kroq-vus-cache';
  var MAX_RETENUS = 12;
  var DUREE_CACHE = 30 * 60 * 1000;
  var SECTIONS = { carte: 'kroq-vus-carte', mini: 'kroq-vus-mini' };
  var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function lire(zone, cle, defaut) {
    try {
      var v = JSON.parse(window[zone].getItem(cle) || 'null');
      return v == null ? defaut : v;
    } catch (e) { return defaut; }
  }
  function ecrire(zone, cle, val) {
    try { window[zone].setItem(cle, JSON.stringify(val)); } catch (e) { /* stockage plein ou bloqué */ }
  }

  function vus() {
    var liste = lire('localStorage', CLE, []);
    return Array.isArray(liste) ? liste.filter(function (h) { return typeof h === 'string' && h; }) : [];
  }

  function retenir(handle) {
    var liste = vus().filter(function (h) { return h !== handle; });
    liste.unshift(handle);
    ecrire('localStorage', CLE, liste.slice(0, MAX_RETENUS));
  }

  function oublier(handle) {
    ecrire('localStorage', CLE, vus().filter(function (h) { return h !== handle; }));
  }

  // Rendu d'un produit, depuis le cache ou depuis Shopify.
  function rendu(handle, format) {
    var cache = lire('sessionStorage', CLE_CACHE, {});
    var cle = format + ':' + handle;
    var entree = cache[cle];
    if (entree && Date.now() - entree.t < DUREE_CACHE) return Promise.resolve(entree.html);

    var url = racine + 'products/' + encodeURIComponent(handle) + '?section_id=' + SECTIONS[format];
    return fetch(url, { headers: { Accept: 'text/html' } }).then(function (res) {
      if (res.status === 404) { oublier(handle); return ''; }
      if (!res.ok) return '';
      return res.text();
    }).then(function (html) {
      if (!html) return '';
      // Shopify enveloppe la section dans un <div id="shopify-section-…"> :
      // on ne garde que son contenu.
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var enveloppe = tmp.querySelector('[id^="shopify-section-"]');
      var interieur = (enveloppe || tmp).innerHTML.trim();
      var c = lire('sessionStorage', CLE_CACHE, {});
      c[cle] = { t: Date.now(), html: interieur };
      ecrire('sessionStorage', CLE_CACHE, c);
      return interieur;
    }).catch(function () { return ''; });
  }

  class KroqVusRecemment extends HTMLElement {
    static get observedAttributes() { return ['data-exclure']; }

    connectedCallback() { this.afficher(); }

    attributeChangedCallback(nom, ancien, nouveau) {
      if (this.isConnected && ancien !== nouveau) this.afficher();
    }

    afficher() {
      var self = this;
      var liste = this.querySelector('[data-kroq-vus-liste]');
      if (!liste) return;
      var format = this.dataset.format === 'mini' ? 'mini' : 'carte';
      var max = parseInt(this.dataset.max, 10) || 4;
      var exclure = (this.dataset.exclure || '').split(',').map(function (h) { return h.trim(); });
      var choix = vus().filter(function (h) { return exclure.indexOf(h) < 0; }).slice(0, max);
      var jeton = (this._jeton = (this._jeton || 0) + 1);

      if (!choix.length) {
        liste.innerHTML = '';
        return;
      }

      Promise.all(choix.map(function (h) { return rendu(h, format); })).then(function (morceaux) {
        if (jeton !== self._jeton) return; // un rendu plus récent a pris la main
        liste.innerHTML = morceaux.filter(Boolean).join('');
      });
    }
  }

  function demarrer() {
    var courant = document.querySelector('[data-kroq-vus-courant]');
    if (courant) retenir(courant.getAttribute('data-kroq-vus-courant'));
    if (!customElements.get('kroq-vus-recemment')) {
      customElements.define('kroq-vus-recemment', KroqVusRecemment);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
